<div class="py-20">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
      <!-- Left Content -->
      <div>
        <div class="flex items-center gap-4 mb-6">
          <div
            class="w-12 h-12 bg-primary-soft/20 border border-primary/30 rounded-xl flex items-center justify-center shadow-subtle"
          >
            <i class="fa-solid fa-bullseye text-primary text-2xl"></i>
          </div>
          <h2 class="h2 text-text-primary">
            {{ 'about.story.title' | translate }}
          </h2>
        </div>

        <p class="text-text-secondary body-large mb-6">
          {{ 'about.story.description' | translate }}
        </p>

       </div>

      <!-- Right Image -->
      <div class="relative h-96 rounded-2xl overflow-hidden shadow-primary-glow border border-border-subtle group">
        <img
          src="https://images.unsplash.com/photo-1709715357520-5e1047a2b691?w=1200&h=800&fit=crop"
          alt="Team"
          class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div class="absolute inset-0 bg-bg-base/10 group-hover:bg-transparent transition-colors duration-500"></div>
      </div>
    </div>
  </div>
</div>
